import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import axios from "axios";

import talentHeroImage from "../../Assets/images/ugaal.png";
import defaultPhoto from "../../Assets/images/avatar.png";
import { getFieldOptions } from "../../../utils/fieldsOptions";

import CVViewer from "../CV Viewer/CVViewer"; 

import "./AlumniTalentPoolPage.css";

const API_BASE_URL = process.env.REACT_APP_BACKEND_API_URL;

export default function AlumniTalentPoolPage() {
  const navigate = useNavigate();
  const [alumniProfiles, setAlumniProfiles] = useState([]);
  const [fieldFilter, setFieldFilter] = useState("");
  const [selectedPdf, setSelectedPdf] = useState(null);
  const fieldOptions = getFieldOptions();

  useEffect(() => {
    const fetchApprovedTalents = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/talent/approved`);
        setAlumniProfiles(res.data);
      } catch (error) {
        console.error("Error fetching approved talents:", error);
      }
    };
    fetchApprovedTalents();
  }, []);

  const handleRegisterClick = () => navigate("/alumni-talent-pool-registration");
  const handleContactClick = () => navigate("/contact-us");
  const handleFieldFilterChange = (e) => setFieldFilter(e.target.value);

  const filteredAlumni = fieldFilter
    ? alumniProfiles.filter((a) => a.field === fieldFilter)
    : alumniProfiles;

  return (
    <div className="talent-page">
      {/* HERO */}
      <motion.section
        className="talent-hero"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <img src={talentHeroImage} alt="Alumni Hero" className="talent-hero-image" />
        <div className="talent-hero-overlay">
          <h1>Alumni Talent Pool</h1>
          <p>Connecting verified alumni with employers seeking talent</p>
        </div>
      </motion.section>

      {/* ABOUT + FILTER + CTA */}
      <motion.section className="talent-about-section" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.2 }}>
        <h2>About the Talent Pool</h2>
        <p>
          The Alumni Talent Pool is a curated database of qualified and verified
          alumni. Employers can discover potential candidates while alumni get
          more visibility and career opportunities.
        </p>

        <motion.div className="talent-cta-buttons" initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.3 }}>
          <button className="talent-btn primary" onClick={handleRegisterClick}>
            Register in Talent Pool
          </button>
        </motion.div>

        <section className="talent-stats-section">
          <motion.div className="talent-stat-card" initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.4 }}>
            <h3>{filteredAlumni.length}</h3>
            <p>Total Registered Alumni</p>
          </motion.div>
        </section>

        <div style={{ marginTop: "24px" }}>
          <select value={fieldFilter} onChange={handleFieldFilterChange} style={{ padding: "10px", borderRadius: "8px", border: "1px solid var(--ug-blue)", minWidth: "200px", fontSize: "14px" }}>
            <option value="">Filter by Field</option>
            {fieldOptions.map((field) => (
              <option key={field} value={field}>{field}</option>
            ))}
          </select>
        </div>
      </motion.section>

      {/* ALUMNI CARDS */}
      <section className="talent-cards-grid">
        {filteredAlumni.map((alumni) => (
          <motion.div key={alumni._id} className="talent-card" whileHover={{ y: -6, boxShadow: "0 12px 25px rgba(0,0,0,0.12)" }} transition={{ duration: 0.3 }}>
            <img src={alumni.photo || defaultPhoto} alt={alumni.name} className="talent-card-photo" onError={(e) => (e.target.src = defaultPhoto)} />
            <h3>{alumni.name}</h3>
            <p className="talent-field">{alumni.field}</p>
            <p className="talent-qualification">{alumni.qualification}</p>

            <div className="talent-card-buttons">
              {alumni.cvLink ? (
                <button className="talent-btn secondary" onClick={() => setSelectedPdf(alumni.cvLink)}>
                  View CV
                </button>
              ) : (
                <button className="talent-btn secondary" disabled>No CV</button>
              )}

              <button className="talent-btn outline" onClick={handleContactClick}>
                Contact Alumni Talent Pool Committee
              </button>
            </div>
          </motion.div>
        ))}
      </section>

      {/* CV VIEWER OVERLAY */}
      {selectedPdf && <CVViewer cvUrl={selectedPdf} onClose={() => setSelectedPdf(null)} />}
    </div>
  );
}